import React, { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    Autocomplete,
    Box,
    Button,
    Card,
    IconButton,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import AddIcon from '@mui/icons-material/Add';

import moment from "moment";
import { useDeleteByIduserMutation, useEditUserMutation, useLazyGetAllTypeOfCompaniesQuery, useLazyGetAllUserQuery } from "../../services/users";
import { AGENCY_TYPE, ROLE } from "../../constants/enums";
import { errorToast, successToast } from "../../helpers";
import Loader from "../../helpers/constants/Loader";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import EditKeyModal from "../../components/EditWarnModal";
import { Clear } from "@mui/icons-material";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";


const ManageSubAdminForCompany = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [getallusers] = useLazyGetAllUserQuery();
    const [page, setPage] = useState(1);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [openEdit, setOpenEdit] = useState<boolean>(false);
    const [selectedId, setSelectedId] = useState<number>(0);
    const [companies, setCompanies] = useState<any>([]);
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [getApprovedCompany] = useLazyGetAllTypeOfCompaniesQuery();

    const onPageChange = (newPage: number) => {
        setPage(newPage);
        setRows1([]);
    };

    const [deleteUserById] = useDeleteByIduserMutation();
    const [totalCount, setTotalCount] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    let totalPages = Math.ceil(totalCount / limit);
    const [rows1, setRows1] = useState<any[]>([]);
    const [editUSERbyId] = useEditUserMutation();
    const changeUserStatus = async (userId: string, userStatus: boolean) => {
        setIsLoading(true);
        try {
            let body = {
                isBlocked: String(userStatus),
            };
            let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
            const response = await editUSERbyId({
                body: encryptedBody,
                id: userId,
            }).unwrap();
            if (response?.statusCode === 200) {
                setIsLoading(false);
                successToast("Status updated successfully");
            }
        } catch (error: any) {
            setIsLoading(false);
            errorToast(error?.message || error?.data?.message);
            console.error(error);
        }
    };

    const fetchData = async (page: number, search: string) => {
        setIsLoading(true);
        try {
            const response = await getallusers({
                page: page,
                search: search,
                limit: limit,
                role: ROLE.SUB_ADMIN_FOR_COMPANY,
                startDate: "",
                endDate: "",
                companyId: selectedCompany || ""
            }).unwrap();
            if (response.statusCode === 200) {
                setIsLoading(false);
                setRows1(response?.data?.user || []);
                setTotalCount(response?.data?.totalCount);
            }
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    };
    const handleDeleteUser = async (userId: any) => {
        setIsLoading(true);
        try {
            const response = await deleteUserById({ userId }).unwrap();
            if (response?.statusCode === 200) {
                setIsLoading(false);
                successToast("Sub-admin deleted successfully");
                fetchData(page, searchTerm);
            }
        } catch (error: any) {
            console.error(error);
            setIsLoading(false);
            errorToast(error?.message || error?.data?.message);
        }
    };

    const fetchCompanies = async () => {
        try {
            const response = await getApprovedCompany({
                role: ROLE.AGENCY
            }).unwrap();
            if (response.statusCode === 200) {
                setCompanies(response?.data || []);
            }
        } catch (error) {
            console.error(error);
        }
    };


    const naviagteFun = () => {
        navigate(`/sub-admin/edit/${selectedId}`)
    }

    useEffect(() => {
        fetchData(page, debouncedSearchTerm);
    }, [page, debouncedSearchTerm, limit, selectedCompany]);

    useEffect(() => {
        fetchCompanies();
    }, [])

    return (
        <div>
            <div className="main_loyout">
                <Loader isLoad={isLoading} />
                <div className="dashboard">
                    <h1 className="mn_hdng">Manage Sub-admin for Company Panel</h1>
                </div>
                <Card className="cards">
                    <Box className="cards_header">
                        <div className="display_f">
                            <SearchBar2
                                value={searchTerm}
                                searchTerm={searchTerm}
                                onCross={() => setSearchTerm("")}
                                setDebouncedSearchTerm={setDebouncedSearchTerm}
                                onChange={(val: any) => {
                                    if (isValidInput(val.target.value)) {
                                        setSearchTerm(val.target.value);
                                        setTimeout(() => {
                                            setPage(1)
                                        }, 1000)
                                    }
                                }}
                            />

                            <Autocomplete
                                options={companies || []}
                                disableClearable
                                getOptionLabel={(option: any) => option?.companyName + " (" + option?.referenceId + ")" || ""}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Company"
                                        variant="outlined"
                                    />
                                )}
                                value={
                                    companies?.find(
                                        (it: any) => it?._id === selectedCompany
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    setSelectedCompany(newValue?._id || "");
                                }}
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option?._id === value?._id
                                }
                            />
                            {selectedCompany ? (
                                <IconButton onClick={() => setSelectedCompany("")} >
                                    <Clear />
                                </IconButton>
                            ) : ("")}


                        </div>
                        <Box className="cards_header_right">
                            <Button
                                className="btn btn_primary"
                                onClick={() => navigate("/sub-admin/add")}
                            >
                                <AddIcon />
                                Add Sub-admin
                            </Button>
                        </Box>
                    </Box>
                    <TableContainer className="table_container">
                        <Box className="heading"></Box>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">S.No</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                    <TableCell>Image</TableCell>
                                    <TableCell>Sub-admin Id</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Phone No.</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Date & time</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Company Name</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows1.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={10} align="center">No Sub-admin Found</TableCell>
                                    </TableRow>
                                ) : (
                                    rows1.map((row: any, i: number) => (
                                        <TableRow key={row?._id}>
                                            <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
                                            <TableCell>
                                                <Box className="table_actions">
                                                    <Tooltip title="View member details">
                                                        <IconButton onClick={() => navigate(`/sub-admin/details/${row?._id}`)}>
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Edit member details">
                                                        <IconButton
                                                            onClick={() => {
                                                                setOpenEdit(true);
                                                                setSelectedId(row?._id);
                                                            }}
                                                        >
                                                            <ModeEditIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete member">
                                                        <IconButton onClick={() => {
                                                            setOpen(true);
                                                            setSelectedId(row?._id);
                                                        }}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <figure onClick={() => navigate(`/affiliate-members-details/${row?._id}`)} className="user_img">
                                                    <img style={{ borderRadius: 0 }} src={row?.image || `/static/images/user_placeholder.png`} alt="" />
                                                </figure>
                                            </TableCell>
                                            <TableCell>{row?.referenceId || "-"}</TableCell>
                                            <TableCell>{row?.name || "-"}</TableCell>
                                            <TableCell>
                                                {row?.phoneNo ? row?.dialCode + row?.phoneNo : "-"}
                                            </TableCell>
                                            <TableCell>
                                                {row?.email || "-"}
                                            </TableCell>
                                            <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell>
                                            <TableCell>
                                                <Switch
                                                    defaultChecked={!row.isBlocked}
                                                    onChange={(e) => {
                                                        const isChecked = !e.target.checked;
                                                        changeUserStatus(row._id, isChecked);
                                                    }}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {row?.subCompanyParentId?.companyName ? row?.subCompanyParentId?.companyName + " (" + row?.subCompanyParentId?.referenceId + ")" : "-"}
                                            </TableCell>


                                        </TableRow>
                                    ))
                                )}

                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </div>
            {rows1?.length > 0 ? (
                <Pagination
                    setPage={setPage}
                    module={rows1}
                    page={page}
                    onPageChange={onPageChange}
                    totalPages={totalPages}
                    limit={limit}
                    setLimit={setLimit}
                />
            ) : (
                ""
            )}
            <WarnModal
                open={open}
                setOpen={setOpen}
                handleDelete={() => handleDeleteUser(selectedId)}
                name="Sub-admin"
            />
            <EditKeyModal
                open={openEdit}
                setOpen={setOpenEdit}
                navigate={naviagteFun}
            />
        </div>
    );
};

export default ManageSubAdminForCompany;
